export { default } from './HoldsExpiryDate';



// WEBPACK FOOTER //
// ./app/components/borrowing/holds/HoldsExpiryDate/index.js